import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SG_TEMPLATES_AVAILABLE_POSTMARK } from 'constants/actions';

export default function AvailablePostmark() {
  const dispatch = useDispatch();
  const available = useSelector((s) => s.action_template?.availablePostmark);
  const [query, setQuery] = useState('');

  useEffect(() => {
    // initial load without query
    dispatch({ type: SG_TEMPLATES_AVAILABLE_POSTMARK, payload: '' });
  }, [dispatch]);

  function run() {
    dispatch({ type: SG_TEMPLATES_AVAILABLE_POSTMARK, payload: query });
  }

  return (
    <div>
      <h2>Available Postmark</h2>
      <div>
        <input value={query} onChange={(e) => setQuery(e.target.value)} placeholder="optional query string" />
        <button onClick={run}>Run</button>
      </div>
      <pre>{available ? JSON.stringify(available, null, 2) : 'No results'}</pre>
    </div>
  );
}
